import { Routes, Route, BrowserRouter, useNavigate } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import { useAppDispatch } from "./store/hooks";
import { Suspense, useEffect } from "react";
import { fetchStoreLocations, fetchStoreMenu } from "./store/storeSlice";
import { useCart, useStore } from "./hooks";
import { privateRoutes, publicRoutes } from "./routes";
import { InfiniteLoader } from "./components";
import { setNavigate } from "./services/NavigationService";
import { Error404 } from "./pages/Error404";

const NavigationInitializer = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  return null;
};

const CART_EXPIRY = 2 * 60 * 60 * 1000;

export const App: React.FC = () => {
  const { storeId } = useStore();
  const { uusid, setUusid, setCartItems } = useCart();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!storeId) return;

    dispatch(fetchStoreMenu(storeId));
    dispatch(fetchStoreLocations(storeId));

    const now = Date.now();

    if (!uusid || now - uusid > CART_EXPIRY) {
      setCartItems([]);
      setUusid(now);
    }
  }, [storeId]);

  return (
    <BrowserRouter basename={`/olo/${storeId}`}>
      <NavigationInitializer />
      <Suspense fallback={<InfiniteLoader />}>
        <Routes>
          {publicRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          <Route element={<PrivateRoute />}>
            {privateRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>

          <Route path="/*" element={<Error404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
